// extracted by mini-css-extract-plugin
export default {"tableHeader":"Users_tableHeader__nu5Yz","column":"Users_column__DnwFc","inviteButton":"Users_inviteButton__S13wS"};